import { Chip } from '@mui/material'

const tagColors = {
  genai: { bg: 'rgba(0, 255, 159, 0.08)', border: '#00ff9f', text: '#00d890', glow: '0 0 6px rgba(0, 255, 159, 0.25)' },
  agents: { bg: 'rgba(0, 212, 255, 0.08)', border: '#00d4ff', text: '#00b8e0', glow: '0 0 6px rgba(0, 212, 255, 0.25)' },
  data: { bg: 'rgba(0, 255, 65, 0.08)', border: '#00ff41', text: '#00d838', glow: '0 0 6px rgba(0, 255, 65, 0.25)' },
  dx: { bg: 'rgba(255, 107, 53, 0.08)', border: '#ff6b35', text: '#e6622f', glow: '0 0 6px rgba(255, 107, 53, 0.25)' },
  security: { bg: 'rgba(255, 0, 110, 0.08)', border: '#ff006e', text: '#e00062', glow: '0 0 6px rgba(255, 0, 110, 0.25)' },
  cost: { bg: 'rgba(255, 107, 53, 0.08)', border: '#ff6b35', text: '#e6622f', glow: '0 0 6px rgba(255, 107, 53, 0.25)' },
  evals: { bg: 'rgba(124, 58, 237, 0.08)', border: '#7c3aed', text: '#9b6dd6', glow: '0 0 6px rgba(124, 58, 237, 0.25)' },
  architecture: { bg: 'rgba(0, 212, 255, 0.08)', border: '#00d4ff', text: '#00b8e0', glow: '0 0 6px rgba(0, 212, 255, 0.25)' },
  ux: { bg: 'rgba(255, 0, 110, 0.08)', border: '#ff006e', text: '#e00062', glow: '0 0 6px rgba(255, 0, 110, 0.25)' },
  rag: { bg: 'rgba(0, 255, 65, 0.08)', border: '#00ff41', text: '#00d838', glow: '0 0 6px rgba(0, 255, 65, 0.25)' },
  quality: { bg: 'rgba(124, 58, 237, 0.08)', border: '#7c3aed', text: '#9b6dd6', glow: '0 0 6px rgba(124, 58, 237, 0.25)' },
  ingestion: { bg: 'rgba(0, 255, 65, 0.08)', border: '#00ff41', text: '#00d838', glow: '0 0 6px rgba(0, 255, 65, 0.25)' },
  production: { bg: 'rgba(255, 107, 53, 0.08)', border: '#ff6b35', text: '#e6622f', glow: '0 0 6px rgba(255, 107, 53, 0.25)' },
  optimization: { bg: 'rgba(0, 212, 255, 0.08)', border: '#00d4ff', text: '#00b8e0', glow: '0 0 6px rgba(0, 212, 255, 0.25)' },
  trust: { bg: 'rgba(255, 0, 110, 0.08)', border: '#ff006e', text: '#e00062', glow: '0 0 6px rgba(255, 0, 110, 0.25)' },
  governance: { bg: 'rgba(0, 212, 255, 0.08)', border: '#00d4ff', text: '#00b8e0', glow: '0 0 6px rgba(0, 212, 255, 0.25)' },
  tools: { bg: 'rgba(0, 255, 159, 0.08)', border: '#00ff9f', text: '#00d890', glow: '0 0 6px rgba(0, 255, 159, 0.25)' },
  testing: { bg: 'rgba(255, 0, 110, 0.08)', border: '#ff006e', text: '#e00062', glow: '0 0 6px rgba(255, 0, 110, 0.25)' },
}

const Tag = ({ tag, size = 'medium', clickable = false, selected = false, onClick }) => {
  const colors = tagColors[tag.toLowerCase()] || tagColors.genai

  return (
    <Chip
      label={tag}
      size={size}
      clickable={clickable}
      onClick={onClick}
      sx={{
        backgroundColor: selected ? colors.border : colors.bg,
        color: selected ? 'var(--color-text-on-accent)' : colors.text,
        border: `1px solid ${colors.border}`,
        fontFamily: 'JetBrains Mono, monospace',
        fontSize: size === 'small' ? '0.7rem' : '0.75rem',
        fontWeight: 600,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        transition: 'all 0.2s ease',
        boxShadow: clickable ? colors.glow : 'none',
        '&:hover': clickable
          ? {
              backgroundColor: colors.border,
              color: 'var(--color-text-on-accent)',
              transform: 'translateY(-1px)',
              boxShadow: `${colors.glow}, 0 2px 8px rgba(0, 0, 0, 0.3)`,
            }
          : {},
      }}
    />
  )
}

export default Tag
